import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useQueryClient, useMutation } from "@tanstack/react-query";
import { Box, Button, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { PROFILES_API } from "../api";
import {
  addNewMessage,
  setPageTitle,
  changeSearchFiltersAvailability,
  removeSearchResults,
} from "../slice";
import { useCurrentState } from "../hooks";
import ConfirmModal from "../components/ConfirmModal";

function StartSearching() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const updateUserStatus = useCurrentState();
  const { data } = useSelector((state) => state.UserCurrentState);
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false);

  const handleClick = (link, status = "") => {
    dispatch(changeSearchFiltersAvailability(false));
    dispatch(removeSearchResults());
    queryClient.removeQueries({ queryKey: ["searchedCandidates"], exact: true });
    const accessCodes = [8, 65, 70, 50];
    if (accessCodes.includes(parseInt(data.code))) {
      if (status === "BY_MANAGER") {
        ChooseSearchByType(true);
      } else {
        ChooseSearchByType(false);
        navigate(`/search-candidates/${link}`);
      }
    } else {
      dispatch(
        addNewMessage({
          id: "failed-on-use",
          text: "متقاضی گرامی این قابلیت در حال حاضر فعال نیست.",
          type: "error",
        })
      );
    }
  };

  const { mutate: ChooseSearchByType } = useMutation(
    (isByBranch) => PROFILES_API.ChooseSearchByType(isByBranch),
    {
      onError: () => {
        setOpenConfirmationModal(false);
        dispatch(
          addNewMessage({
            id: "error-on-search",
            text: "مشکلی برای ارسال درخواست شما به وجود آمده است.",
            type: "error",
          })
        );
      },
      onSuccess: () => {
        updateUserStatus();
        if (openConfirmationModal) {
          dispatch(
            addNewMessage({
              text: "درخواست شما با موفقیت ارسال شد.",
              id: "success-on-search",
              type: "success",
            })
          );
        }
        setOpenConfirmationModal(false);
      },
    }
  );

  useEffect(() => {
    dispatch(setPageTitle("جستجو و کاندیدها"));
  }, [dispatch]);

  return (
    <Box display="flex" flexDirection="column" alignItems="center" width="100%">
      <ConfirmModal
        message="متقاضی گرامی درصورت انتخاب درخواست به مرکز، امکان ادامه‌ی جستجو و ارسال کاندیدهای منتخب توسط خود شما وجود ندارد. آیا اطمینان دارید؟"
        open={openConfirmationModal}
        onClose={() => setOpenConfirmationModal(false)}
        onSubmit={() => handleClick("", "BY_MANAGER")}
      />
      <Box display="flex" justifyContent="space-between" alignItems="center" width="100%" mb={10}>
        <Button variant="s1" onClick={() => handleClick("candidate")}>
          کاندیدها
        </Button>
      </Box>
      <Box
        width="90%"
        maxWidth="450px"
        bgcolor="#EEEEEE"
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        sx={{ boxSizing: "border-box", padding: 5 }}
        my={3}
        borderRadius={3}
      >
        <Typography variant="h1" mb={5} textAlign="center" sx={{ direction: "rtl" }}>
          می خواهم خودم گزینه مناسب را جستجو کنم.
        </Typography>
        <Button variant="m1" onClick={() => handleClick("search")}>
          شروع جستجو
        </Button>
      </Box>
      <Box
        width="90%"
        maxWidth="450px"
        bgcolor="#EEEEEE"
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        sx={{ boxSizing: "border-box", padding: 5 }}
        my={3}
        borderRadius={3}
      >
        <Typography variant="h1" mb={5} textAlign="center" sx={{ direction: "rtl" }}>
          می‌خواهم مرکز گزینه مناسب را جستجو کند.
        </Typography>
        <Typography
          variant="h6"
          mb={5}
          textAlign="center"
          sx={{ direction: "rtl", whiteSpace: { md: "nowrap", sm: "normal" } }}
        >
          پیشنهاد می‌کنیم جستجو را به کارشناسان مرکز بسپارید...
        </Typography>
        <Button variant="m1" onClick={() => setOpenConfirmationModal(true)}>
          درخواست به مرکز
        </Button>
      </Box>
    </Box>
  );
}

export default StartSearching;
